module.exports = __webpack_public_path__ + "img/test-laboratorium.f422138a.png";